import { useMutation } from '@tanstack/react-query'
import { UseBaseMutationOptions } from '@/core/api/type'
import { MessagingMutationKey } from '../../keys'
import MessagingService from '../services'
import {
	CreateMessageTransactionRequest,
	GetMessageResponse,
} from '../../types'

function useMutationCreateMessage(
	props?: UseBaseMutationOptions<
		GetMessageResponse,
		CreateMessageTransactionRequest
	>,
) {
	return useMutation({
		mutationKey: [MessagingMutationKey.CreateMessageTransaction],
		mutationFn: (data: CreateMessageTransactionRequest) =>
			MessagingService.createMessageTransaction(data),
		...props,
	})
}

export default useMutationCreateMessage
